import { Component, inject } from '@angular/core';

import { DIALOG_DATA } from '@angular/cdk/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ui-document-preview',
  imports: [],
  templateUrl: './document-preview.component.html',
})
export class DocumentPreviewComponent {
  data = inject<{
    url: string;
    title: string;
  }>(DIALOG_DATA);
  private dom = inject(DomSanitizer);

  _url: SafeResourceUrl | undefined;
  constructor() {
    const data = this.data;

    this._url = this.dom.bypassSecurityTrustResourceUrl(data.url);
  }
}
